import React from 'react'
import Layout from '..'
import Guidelines from '../Guidelines/Guidelines'
function Roadmap() {
    return (
        <Layout>
            <Guidelines />
        </Layout>
    )
}

export default Roadmap